import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { useAuth } from "@/context/AuthContext";

export const SiteNav = () => {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 bg-white/85 dark:bg-slate-950/85 backdrop-blur-md border-b border-slate-200 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Logo />
        <nav className="flex items-center gap-2 sm:gap-4">
          <a href="/#how" className="hidden md:inline text-sm text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-colors" data-testid="nav-how-link">How it works</a>
          <a href="/#pricing" className="hidden md:inline text-sm text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-colors" data-testid="nav-pricing-link">Pricing</a>
          <Link to="/enterprise" className="hidden md:inline text-sm text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-colors" data-testid="nav-enterprise-link">Enterprise</Link>
          <Link to="/verify" className="hidden md:inline text-sm text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-colors" data-testid="nav-verify-link">Verify certificate</Link>
          <ThemeToggle />
          {user ? (
            <Link to="/app" data-testid="nav-dashboard-btn" className="text-sm font-semibold px-4 py-2 rounded-full bg-slate-900 text-white dark:bg-white dark:text-slate-900 hover:bg-emerald-600 dark:hover:bg-emerald-500 dark:hover:text-white transition-colors">Dashboard</Link>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn" className="hidden sm:inline text-sm font-medium px-3 py-2 whitespace-nowrap hover:text-emerald-600 transition-colors">Sign in</Link>
              <Link to="/register" data-testid="nav-register-btn" className="whitespace-nowrap text-sm font-semibold px-4 py-2 rounded-full bg-slate-900 text-white dark:bg-white dark:text-slate-900 hover:bg-emerald-600 dark:hover:bg-emerald-500 dark:hover:text-white transition-colors">Get started</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
